import { Component, OnInit } from '@angular/core';
import { CartService } from "../services/cart/cart.service";
import { environment } from "../../environments/environment";
import { CategoryService } from '../services/category/category.service';
@Component({
  selector: 'app-panier',
  templateUrl: './panier.component.html',
  styleUrls: ['./panier.component.css']
})
export class PanierComponent implements OnInit {
  card=[];
  total=0;
  tva = 0;
  baseUrl = environment.baseUrl
  isB2b =false;
  constructor(private cartService:CartService,private categoryService:CategoryService) { }

  ngOnInit(): void {
    if (localStorage.getItem('card')) {
      this.card = JSON.parse(localStorage.getItem('card'));
      this.sommeTotel();
    }
    
    if(localStorage.getItem('user') && localStorage.getItem('user')!='null')
    {
    
      if (localStorage.getItem('typeCompte') && localStorage.getItem('typeCompte')!='null') {
        if (localStorage.getItem('typeCompte') == "B2B") {
          this.isB2b=true
        }else
        {
          this.isB2b=false
        }
      } else {
        this.isB2b=false
      }
      
    }else{
      this.isB2b=false
    }
    
  }

  changeQte(qte,item,i)
  {
    if(item.product.DET != 0 && qte>=item.product.DET){
      this.card.forEach(itemCard => {
        if (item.product.ITMREF==itemCard.product.ITMREF) {
          var q = parseInt(qte)/parseInt(item.product.DET)
          itemCard.item_quantity = ''+(parseInt(item.product.DET)*parseInt(q.toFixed()))
          this.sommeTotel();
          this.cartService.updateItemCart([{
              "item_ref": itemCard.product.ITMREF,
              "item_quantity": itemCard.item_quantity
          }]).subscribe(res=>console.log(res))

        }
      });
      localStorage.setItem('card',JSON.stringify(this.card))
    }else{
      console.log('qte invalide',i);
      this.card[i].item_quantity = item.product.DET;
      localStorage.setItem('card',JSON.stringify(this.card))
    }

  }

  sommeTotel()
  {
    this.total = 0;
    this.tva = 0;

    for (let i = 0; i < this.card.length; i++) {
      this.total += this.card[i].item_quantity * parseInt(this.card[i].product.PRIXNET);
    }

    this.tva =  20 * this.total / 100;
  }

  removeItem(id)
  {
    this.card.forEach(itemCard => {
      if (id==itemCard.product.ITMREF)
      {
        var index = this.card.indexOf(itemCard)
        this.card.splice(index, 1);

        this.total -=  itemCard.item_quantity*parseInt(itemCard.product.PRIXNET);
        this.tva =  20 * this.total / 100;
        this.cartService.panierCount--;
        this.cartService.removeFromCart(itemCard.product.ITMREF).subscribe(res=>{


        })
      }
    });
    localStorage.setItem('card',JSON.stringify(this.card));
    if (this.card.length == 0) {
      localStorage.removeItem('card')
    }
  }



}
